"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var DataSync = _interopRequireWildcard(require("./util/DataSync"));

var Log = _interopRequireWildcard(require("./util/Log"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * User device
 * @access protected
 */
var Device =
/*#__PURE__*/
function () {
  /**
   * Create a device
   * @param {Webcom/api.DataSnapshot|object} snapData The data snapshot
   * @access protected
   */
  function Device(snapData) {
    _classCallCheck(this, Device);

    var values = Object.assign({}, snapData.val());
    /**
     * Device's unique id
     * @type string
     */

    this.uid = snapData.name();
    /**
     * Device's OS
     * @type {string}
     */

    this.os = values.os;
    /**
     * Device's userAgent
     * @type {string}
     */

    this.userAgent = values.userAgent;
    /**
     * Device's last know status
     * - CONNECTED
     * - NOT_CONNECTED
     * - SLEEPING
     * @type {string}
     */

    this.status = values.status;
    /**
     * Device's sdk
     * @type {{reach: string, webcom: string}}
     */

    this.sdk = values.sdk; // TODO #Feat: Add 'extra' property for unrestricted additional information ?
  }
  /**
   * Get a device by its user uid and its uid
   * @access private
   * @param {string} userUid The user's uid
   * @param {string} deviceUid The device's uid
   * @returns {Promise<Device, Error>}
   */


  _createClass(Device, null, [{
    key: "get",
    value: function get(userUid, deviceUid) {
      // due to the problem of long list, some uid (uid of participant)
      // can have a : instead of /
      var newUid = userUid.replace(/:/g, '/');
      return DataSync.get("_/devices/".concat(newUid, "/").concat(deviceUid)).then(function (snapData) {
        return snapData ? new Device(snapData) : null;
      }).catch(Log.r('Device#get'));
    }
  }]);

  return Device;
}();

exports.default = Device;